import { UserRole } from '../types';

const roleOrder: UserRole[] = [
  UserRole.ROLE_SUPER_ADMIN,
  UserRole.ROLE_ADMIN,
  UserRole.ROLE_SUPPORT,
  UserRole.ROLE_MANAGER,
  UserRole.ROLE_ASSISTANT,
  UserRole.ROLE_CONSULTATION,
  UserRole.ROLE_ACCEPTED_TOS,
  UserRole.ROLE_USER,
];

export const autoriserAcces = (userRoles: UserRole[], requiredRole: UserRole): boolean => {
  const authorizedRoles = roleOrder.slice(0, roleOrder.indexOf(requiredRole) + 1);
  const userIndex = userRoles.map(role => authorizedRoles.includes(role)).indexOf(true);
  return userIndex !== -1;
};
